import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100%;
    width: 100%;
    padding-left:10%;
    padding-right:10%;
    position: relative;
`;

export const VerticallyCenterContainer = styled.div`
    width: 100%;
    margin: 0;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-top: 200px;
`;

export const NewButtonContainer = styled.div`
    display: flex;
`;

export const BotListContainer = styled.div`
    position: relative;
    display: flex;
    width: auto;
    height: auto;
    flex-wrap: wrap;
`;

export const BannerContainer = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: auto;
    flex-wrap: wrap;
    > * {
        margin: auto;
    }
`;
